import type { ComponentProps } from "./statistics.d";
import "./statistics.scss";

import React from "react";

import { useAppStore } from "../../../react4xp/shared/stores";

function Component(props: ComponentProps) {
	const { items } = props;
	const visibleItemsCount = 3;

	const appStore = useAppStore((state) => state);

	return (
		<section className={`statistics`}>
			<div className={`d-md-flex gap-2`}>
				{items.hits.length > 0 && (
					<div className="grid-layout">
						{items.hits.map(({ _id, displayName, data: { contentTypeImage, contentTypeImageAltText, value } }, j) => (
							<div key={_id} className={`stat-card border-0 ${j < visibleItemsCount ? "" : "d-none"}`}>
								<div className="card-body d-flex">
									<div>
										{contentTypeImage && (
											<img src={contentTypeImage} alt={contentTypeImageAltText} loading="lazy" className="stat-img" />
										)}
									</div>
									<div className="stat-line"></div>
									<div className="stat-text">
										<p className="stat-name">{displayName}</p>
										<p className="stat-value">{value || ""}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				)}

				{items.hits.length === 0 && (
					<div className="empty">
						<h3>{appStore.phrases?.["empty"]}</h3>
					</div>
				)}
			</div>
		</section>
	);
}

export default function WrappedComponent(props: ComponentProps) {
	return <Component {...props} />;
}
